import React from "react";
import "./MenuGrid.css";
import { Link } from "react-router-dom";

function MenuGrid() {
  return (
    <>
      <section className="MenuGrid">
        <div className="menu-grid">
          <Link to={"/game-history"}>
            <div className="menu-item">
              <div className="icon_img_holder">
                <div className="img_holder">
                  <img
                    src="/assets/images/icons/transaction.png"
                    className="icon_img"
                    alt="icon img"
                  />
                </div>
              </div>
              <div>
                <h3>Game History </h3>
                <p>My Game History</p>
              </div>
            </div>
          </Link>
          <Link to={"/transaction-history"}>
            <div className="menu-item">
              <div className="icon_img_holder">
                <div className="img_holder">
                  <img
                    src="/assets/images/icons/game_history.png"
                    className="icon_img"
                    alt="icon img"
                  />
                </div>
              </div>
              <div>
                <h3>Transaction </h3>
                <p>My Transaction History</p>
              </div>
            </div>
          </Link>

          <Link to={"/deposite-history"}>
            <div className="menu-item">
              <div className="icon_img_holder">
                <div className="img_holder">
                  <img
                    src="/assets/images/icons/wallet.png"
                    className="icon_img"
                    alt="icon img"
                  />
                </div>
              </div>
              <div>
                <h3>Deposit </h3>
                <p>My Deposit History</p>
              </div>
            </div>
          </Link>

          <Link to={"/withdrawal-history"}>
            <div className="menu-item">
              <div className="icon_img_holder">
                <div className="img_holder">
                  <img
                    src="/assets/images/icons/code_screen.png"
                    className="icon_img"
                    alt="icon img"
                  />
                </div>
              </div>
              <div>
                <h3>Withdraw </h3>
                <p>My Withdraw History</p>
              </div>
            </div>
          </Link>
        </div>
      </section>
    </>
  );
}

export default MenuGrid;
